import Link from '../../../links/Link';
import React from 'react';
function CompanyProfileLink({ linkComponent, url, underline, children, openInNewTab, }) {
    const LinkItem = () => linkComponent
        ? React.cloneElement(linkComponent, {
            to: url,
            href: url,
            isExternal: openInNewTab,
            openInNewTab,
            underline,
        }, children)
        : null;
    return (<>
      {LinkItem() || (<Link href={url} target={openInNewTab ? '_blank' : ''} className="link-wrapper" rel="noreferrer">
          <>{children}</>
        </Link>)}
    </>);
}
CompanyProfileLink.defaultProps = {
    linkComponent: null,
    underline: false,
};
export default CompanyProfileLink;
